<div class="flex h-full flex-col gap-4" *transloco="let t">
  <div class="flex items-center justify-between">
    <div class="font-medium text-gray-600">{{ t("sd-strategy-creation.advertised_products") }}</div>

    <div class="flex gap-2">
      <button
        iButton
        variant="destructive"
        [ngClass]="{ 'opacity-100': selectedAsins().length > 0 }"
        class="opacity-0"
        [disabled]="isAllAsinsSelected()"
        [loading]="deleteAsinLoading()"
        [iTooltip]="isAllAsinsSelected() ? t('strategy-page.cannot_delete_all_products') : undefined"
        (click)="deleteProductsFromStrategy(selectedAsins())"
      >
        <IIcon name="trash" />
        {{ deleteButtonLabel() }}
      </button>
      <button iButton variant="secondary" [disabled]="isReadOnly()" (click)="openAddAsinsModal()">
        <IIcon name="add" />
        {{ t("sp-substrategy.add_products") }}
      </button>
    </div>
  </div>
  <app-asin-selection
    class="min-h-0 flex-[1_1_0]"
    ineligibilityTag="SP"
    [customList]="strategyGroupAsins()"
    [readonly]="isReadOnly()"
    [csvExport]="true"
    [withBulk]="false"
    [withGroupByParent]="false"
    [(selectedAsins)]="selectedAsins"
  />

  <ng-template #addAsinsModal>
    @if (addAsinsModalState() === AddAsinsModalState.PRODUCTS) {
      <div class="flex h-full flex-col gap-4">
        <app-asin-selection
          class="min-h-0 flex-1"
          [customList]="availableAsins()"
          [readonly]="isReadOnly()"
          [(selectedAsins)]="addAsinsSelected"
        />

        <div class="flex justify-end gap-2">
          <button iButton variant="secondary" (click)="closeAddProductsModal()">{{ t("common.cancel") }}</button>
          <button
            iButton
            [disabled]="addAsinsSelected().length === 0"
            (click)="addAsinsModalState.set(AddAsinsModalState.STRATEGY)"
          >
            {{ t("common.continue") }}
          </button>
        </div>
      </div>
    }
    @if (addAsinsModalState() === AddAsinsModalState.STRATEGY) {
      <div class="flex flex-col gap-4 duration-150">
        <div class="flex flex-1 flex-col gap-4 divide-y divide-gray-200">
          <div class="flex flex-col gap-2">
            <span class="text-sm font-medium text-gray-600">{{
              t("sp-strategy-group-page.select_main_strategy")
            }}</span>
            <ISelectMenu [(value)]="selectedMainStrategy" by="strategyId" fitTriggerWidth>
              <ISelectTrigger class="flex w-full">
                <ISelectValue>
                  <div *iSelectValue="let value">{{ value?.name }}</div>
                </ISelectValue>
              </ISelectTrigger>
              <ISelectContent>
                @for (strategy of strategyGroupProductStrategies(); track strategy.strategyId) {
                  <ISelectOption [value]="strategy">
                    {{ strategy.name }}
                  </ISelectOption>
                }
              </ISelectContent>
            </ISelectMenu>
          </div>

          @if (strategyGroup()?.brandStrategies?.length) {
            <div class="space-y-2 pt-4">
              <span class="text-sm font-medium text-gray-600">{{
                t("sp-strategy-group-page.select_brand_defense_strategy")
              }}</span>
              <div class="flex flex-col gap-2">
                @for (s of strategyGroup()?.brandStrategies; track s.strategyId) {
                  <div class="flex items-center gap-2">
                    <ICheckbox
                      [label]="s.name"
                      [value]="strategyGroupBrandSelection.has(s.strategyId)"
                      (valueChange)="toggleStrategyToSelection(s, $event)"
                    />
                  </div>
                }
              </div>
            </div>
          }

          @if (strategyGroup()?.keywordStrategies?.length) {
            <div class="space-y-2 pt-4">
              <span class="text-sm font-medium text-gray-600">{{
                t("sp-strategy-group-page.select_focus_strategy")
              }}</span>
              <div class="flex flex-col gap-2">
                @for (s of strategyGroup()?.keywordStrategies; track s.strategyId) {
                  <div class="flex items-center gap-2">
                    <ICheckbox
                      [label]="s.name"
                      [value]="strategyGroupFocusSelection.has(s.strategyId)"
                      (valueChange)="toggleStrategyToSelection(s, $event)"
                    />
                  </div>
                }
              </div>
            </div>
          }
        </div>
        <div class="flex justify-end gap-2">
          <button iButton variant="secondary" (click)="addAsinsModalState.set(AddAsinsModalState.PRODUCTS)">
            {{ t("common.previous") }}
          </button>
          <button
            iButton
            [disabled]="addAsinsSelected().length === 0"
            [loading]="addAsinsLoading()"
            (click)="addProducts()"
          >
            {{ t("sp-substrategy.add_n_products", { count: addAsinsSelected().length }) }}
          </button>
        </div>
      </div>
    }
  </ng-template>
</div>
